// Elegant deer icon for the header
export function DeerIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 4l-2 2M6 4l2 2"/>
      <path d="M12 8c-2.5 0-4.5 2-4.5 4.5V16c0 2.5 2 4 4.5 4s4.5-1.5 4.5-4v-3.5C16.5 10 14.5 8 12 8z"/>
      <path d="M9 15h.01M15 15h.01"/>
      <path d="M16 4c1.5 1.5 2 3 2 4M8 4c-1.5 1.5-2 3-2 4"/>
    </svg>
  )
}
